import { render, staticRenderFns } from "./DaysDiference.vue?vue&type=template&id=05a988cc&scoped=true&"
import script from "./DaysDiference.vue?vue&type=script&lang=js&"
export * from "./DaysDiference.vue?vue&type=script&lang=js&"
import style0 from "./DaysDiference.vue?vue&type=style&index=0&id=05a988cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a988cc",
  null
  
)

export default component.exports